import { LineString } from 'ol/geom';
import { SELECTED_SEGMENTS } from '../constants';
import { getIntersectionScore } from '../utils/getIntersectionScore';
import { getLinesIntersection } from './getLinesIntersection';
import { getPointsDistance } from './distance';
const getDistanceFromSegment = (segmentStartPoint, segmentEndPoint, coordinate) => {
    const segmentLineGeom = new LineString([segmentStartPoint, segmentEndPoint]);
    const segmentClosestPoint = segmentLineGeom.getClosestPoint(coordinate);
    const distance = getPointsDistance(coordinate, segmentClosestPoint);
    return distance;
};
export const getIntersectionSegmentIndex = (coordinate, multiLineString) => {
    let closestDistance = Infinity;
    let oneSegment = {
        lineStringSegmentIndex: null,
        lineStringIndex: null,
    };
    multiLineString.forEach((lineString, lineStringIndex) => {
        const lineStringLength = lineString.length;
        for (let lineStringSegmentIndex = 0; lineStringSegmentIndex < lineStringLength - 1; lineStringSegmentIndex++) {
            const highlightSegmentStartPoint = lineString[lineStringSegmentIndex];
            const highlightSegmentEndPoint = lineString[lineStringSegmentIndex + 1];
            const currentDistance = getDistanceFromSegment(highlightSegmentStartPoint, highlightSegmentEndPoint, coordinate);
            if (currentDistance < closestDistance) {
                oneSegment = { lineStringSegmentIndex, lineStringIndex };
                closestDistance = currentDistance;
            }
        }
    });
    return oneSegment;
};
export const getIntersectionCoord = (intersectionInteraction, coordinate, editLineStrings, highlightLineStrings) => {
    let score = 0;
    let intersectionCoord = null;
    const oneSegment = getIntersectionSegmentIndex(coordinate, highlightLineStrings);
    editLineStrings.forEach((editLineString) => {
        const editLength = editLineString.length;
        for (let i = 0; i < editLength - 1; i++) {
            const editSegmentStartPoint = editLineString[i];
            const editSegmentEndPoint = editLineString[i + 1];
            const isLastSegment = i === editLength - 2;
            const editSegment = (isLastSegment
                ? [editSegmentEndPoint, editSegmentStartPoint]
                : [editSegmentStartPoint, editSegmentEndPoint]);
            const isEditOuter = i === 0 || isLastSegment;
            const isEditOne = false;
            // eslint-disable-next-line no-loop-func
            highlightLineStrings.forEach((highlightLineString, highlightLineStringIndex) => {
                const highlightLength = highlightLineString.length;
                for (let j = 0; j < highlightLength - 1; j++) {
                    const highlightSegmentStartPoint = highlightLineString[j];
                    const highlightSegmentEndPoint = highlightLineString[j + 1];
                    const isLastSegment = j === highlightLength - 2;
                    const highlightSegment = (isLastSegment
                        ? [highlightSegmentEndPoint, highlightSegmentStartPoint]
                        : [highlightSegmentStartPoint, highlightSegmentEndPoint]);
                    const isHighlightOuter = j === 0 || isLastSegment;
                    const isHighlightOne = j === oneSegment.lineStringSegmentIndex &&
                        highlightLineStringIndex === oneSegment.lineStringIndex;
                    if ((intersectionInteraction.selectedEditSegments === SELECTED_SEGMENTS.ALL ||
                        (intersectionInteraction.selectedEditSegments === SELECTED_SEGMENTS.OUTER &&
                            isEditOuter) ||
                        (intersectionInteraction.selectedEditSegments === SELECTED_SEGMENTS.ONE &&
                            isEditOne)) &&
                        (intersectionInteraction.selectedHighlightSegments === SELECTED_SEGMENTS.ALL ||
                            (intersectionInteraction.selectedHighlightSegments === SELECTED_SEGMENTS.OUTER &&
                                isHighlightOuter) ||
                            (intersectionInteraction.selectedHighlightSegments === SELECTED_SEGMENTS.ONE &&
                                isHighlightOne))) {
                        const currentIntersectionCoord = getLinesIntersection(editSegment, highlightSegment);
                        const currentScore = getIntersectionScore(intersectionInteraction, coordinate, editSegment, highlightSegment, currentIntersectionCoord);
                        if (currentScore > score) {
                            intersectionCoord = currentIntersectionCoord;
                            score = currentScore;
                        }
                    }
                }
            });
        }
    });
    return intersectionCoord;
};
//# sourceMappingURL=getIntersectionCoord.js.map